export default () => {
  if( typeof window === 'undefined' ) return false
  if( typeof navigator === 'undefined' ) return false
  return ('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0)
}